'use client'

export { H1 } from './H1'
export { H2 } from './H2'
export { H3 } from './H3'
export { H4 } from './H4'
